import {
  Col,
  Container,
  Option,
  Row,
  Select,
  Title
} from '@qonsoll/react-design'

import PropTypes from 'prop-types'
import { STATUSES } from '__constants__'
import { capitalizeFirstLetter } from 'utils'
import { useGetNewsTipStatuses } from 'domains/NewsTipStatus/hooks'
import { useTranslations } from 'contexts/Translation'

// Takes a value of type object and onChange function
// Returns selected option object
const NewsTipStatusSelect = (props) => {
  const {
    value,
    onChange,
    showTitle = true,
    allowClear = true,
    mode,
    ...rest
  } = props
  /* Getting all possibility variants for select */
  const [allNewsTipStatuses] = useGetNewsTipStatuses()
  /* Getting translation instance */
  const { t } = useTranslations()
  /* Handling change selected option */
  const handleChange = (value) => onChange?.(value)
  const isTipAccepted = value === STATUSES.NEWS_TIP_STATUSES.APPROVED
  return (
    <Container {...rest}>
      {showTitle && (
        <Title mb={2} level={4}>
          {t('News tip status')}
        </Title>
      )}
      <Row noGutters>
        <Col>
          <Select
            mode={mode}
            disabled={isTipAccepted}
            allowClear={allowClear}
            placeholder={t('Please, select news tip status')}
            value={value}
            onChange={handleChange}>
            {allNewsTipStatuses?.map((newsTipStatus) => (
              <Option key={newsTipStatus} value={newsTipStatus}>
                {capitalizeFirstLetter(newsTipStatus?.toLocaleLowerCase())}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    </Container>
  )
}

NewsTipStatusSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  showTitle: PropTypes.bool,
  allowClear: PropTypes.bool,
  mode: PropTypes.string
}

export default NewsTipStatusSelect
